import { createReducer } from 'utils'
import { fromJS } from 'immutable'
import {
  SHOW_SNACKBAR,
  SHOW_STICKY_SNACKBAR,
  SHOW_ZIPCODE_SNACKBAR,
  HIDE_SNACKBAR
} from '../actions/snackbar'

export const initialState = fromJS({
  isVisible: false,
  isSticky: false,
  message: null
})

// isSticky is what tells the messages apart on screen: only the one that waits
// for the user carries a close button, because it is the only one the user has
// to take away by hand. The rest go on their own after a few seconds.
const show = (state, payload, isSticky) =>
  state.set('isVisible', true).set('isSticky', isSticky).set('message', payload)

export default createReducer(initialState, {
  [SHOW_SNACKBAR]: (state, { payload }) => show(state, payload, false),
  [SHOW_STICKY_SNACKBAR]: (state, { payload }) => show(state, payload, true),
  [SHOW_ZIPCODE_SNACKBAR]: (state, { payload }) => show(state, payload, false),
  [HIDE_SNACKBAR]: () => initialState
})
